import { ReactNode } from 'react';
import { ClientOrg, Household, OrgId } from '../../../../common/src/model.ts';
import { LocalStorageMockProvider, LocalStorageMockValues } from '../../test/local_storage.mock.tsx';
import { LocalStorageKey } from '../client_local_storage.ts';

export function getCurrentOrgMockValues({
  household,
  currentOrgId,
  cachedOrgs,
}: {
  household: Pick<Household, 'orgIds'>;
  currentOrgId?: OrgId;
  cachedOrgs: ClientOrg[];
}): LocalStorageMockValues {
  return {
    [LocalStorageKey.Household]: household as Household,
    [LocalStorageKey.CurrentOrgId]: currentOrgId,
    [LocalStorageKey.CachedOrgs]: cachedOrgs,
  };
}

export const CurrentOrgMockProvider = ({
  household,
  currentOrgId,
  cachedOrgs,
  children,
}: {
  household: Pick<Household, 'orgIds'>;
  currentOrgId?: OrgId;
  cachedOrgs: ClientOrg[];
  children: ReactNode;
}) => {
  const localStorageValues = getCurrentOrgMockValues({ household, currentOrgId, cachedOrgs });
  return <LocalStorageMockProvider values={localStorageValues}>{children}</LocalStorageMockProvider>;
};
